/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateBroadcastMessageDto } from '../model/createBroadcastMessageDto';
import { MessageResponseDto } from '../model/messageResponseDto';
import { QueuedSmsJobDto } from '../model/queuedSmsJobDto';
import { QueuedSmsJobModel } from '../model/queuedSmsJobModel';
import { ServiceMessageModel } from '../model/serviceMessageModel';
import { SmsMessage } from '../model/smsMessage';
import { SmsMessageBody } from '../model/smsMessageBody';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MessageService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param creatorId 
     * @param searchWord 
     * @param referenceNumber 
     * @param skip 
     * @param take 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageGetFailedMessages(creatorId?: string, searchWord?: string, referenceNumber?: string, skip?: number, take?: number, startDate?: Date, endDate?: Date, observe?: 'body', reportProgress?: boolean): Observable<QueuedSmsJobDto>;
    public messageGetFailedMessages(creatorId?: string, searchWord?: string, referenceNumber?: string, skip?: number, take?: number, startDate?: Date, endDate?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QueuedSmsJobDto>>;
    public messageGetFailedMessages(creatorId?: string, searchWord?: string, referenceNumber?: string, skip?: number, take?: number, startDate?: Date, endDate?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QueuedSmsJobDto>>;
    public messageGetFailedMessages(creatorId?: string, searchWord?: string, referenceNumber?: string, skip?: number, take?: number, startDate?: Date, endDate?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (searchWord !== undefined && searchWord !== null) {
            queryParameters = queryParameters.set('searchWord', <any>searchWord);
        }
        if (referenceNumber !== undefined && referenceNumber !== null) {
            queryParameters = queryParameters.set('referenceNumber', <any>referenceNumber);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<QueuedSmsJobDto>(`${this.basePath}/api/Message/GetFailedMessages`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param jobState 
     * @param updateWithState 
     * @param smsType 
     * @param updateWithStateReason 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageGetQueuedSmsMessages(jobState?: number, updateWithState?: number, smsType?: number, updateWithStateReason?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<SmsMessage>;
    public messageGetQueuedSmsMessages(jobState?: number, updateWithState?: number, smsType?: number, updateWithStateReason?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsMessage>>;
    public messageGetQueuedSmsMessages(jobState?: number, updateWithState?: number, smsType?: number, updateWithStateReason?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsMessage>>;
    public messageGetQueuedSmsMessages(jobState?: number, updateWithState?: number, smsType?: number, updateWithStateReason?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (jobState !== undefined && jobState !== null) {
            queryParameters = queryParameters.set('jobState', <any>jobState);
        }
        if (updateWithState !== undefined && updateWithState !== null) {
            queryParameters = queryParameters.set('updateWithState', <any>updateWithState);
        }
        if (smsType !== undefined && smsType !== null) {
            queryParameters = queryParameters.set('smsType', <any>smsType);
        }
        if (updateWithStateReason !== undefined && updateWithStateReason !== null) {
            queryParameters = queryParameters.set('updateWithStateReason', <any>updateWithStateReason);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsMessage>(`${this.basePath}/api/Message/queuedsmsjobs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageGetSmsMessage(id: string, observe?: 'body', reportProgress?: boolean): Observable<SmsMessage>;
    public messageGetSmsMessage(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsMessage>>;
    public messageGetSmsMessage(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsMessage>>;
    public messageGetSmsMessage(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling messageGetSmsMessage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsMessage>(`${this.basePath}/api/Message/sms/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param referenceNumber 
     * @param creatorId 
     * @param startIndex 
     * @param count 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageGetSmsMessageByReferenceNumber(referenceNumber: string, creatorId?: string, startIndex?: number, count?: number, startDate?: Date, endDate?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<QueuedSmsJobModel>>;
    public messageGetSmsMessageByReferenceNumber(referenceNumber: string, creatorId?: string, startIndex?: number, count?: number, startDate?: Date, endDate?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<QueuedSmsJobModel>>>;
    public messageGetSmsMessageByReferenceNumber(referenceNumber: string, creatorId?: string, startIndex?: number, count?: number, startDate?: Date, endDate?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<QueuedSmsJobModel>>>;
    public messageGetSmsMessageByReferenceNumber(referenceNumber: string, creatorId?: string, startIndex?: number, count?: number, startDate?: Date, endDate?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (referenceNumber === null || referenceNumber === undefined) {
            throw new Error('Required parameter referenceNumber was null or undefined when calling messageGetSmsMessageByReferenceNumber.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<QueuedSmsJobModel>>(`${this.basePath}/api/Message/sms/reference/${encodeURIComponent(String(referenceNumber))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageInternalPostSms(model: SmsMessageBody, observe?: 'body', reportProgress?: boolean): Observable<MessageResponseDto>;
    public messageInternalPostSms(model: SmsMessageBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MessageResponseDto>>;
    public messageInternalPostSms(model: SmsMessageBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MessageResponseDto>>;
    public messageInternalPostSms(model: SmsMessageBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling messageInternalPostSms.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MessageResponseDto>(`${this.basePath}/api/Message/internalpostsms`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param message 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messagePostBCMessage(message: CreateBroadcastMessageDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public messagePostBCMessage(message: CreateBroadcastMessageDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public messagePostBCMessage(message: CreateBroadcastMessageDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public messagePostBCMessage(message: CreateBroadcastMessageDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (message === null || message === undefined) {
            throw new Error('Required parameter message was null or undefined when calling messagePostBCMessage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Message/PostBCMessage`,
            message,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messagePostBroadCastMessage(model: SmsMessageBody, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public messagePostBroadCastMessage(model: SmsMessageBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public messagePostBroadCastMessage(model: SmsMessageBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public messagePostBroadCastMessage(model: SmsMessageBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling messagePostBroadCastMessage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Message/postbroadcast`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messagePostBroadCastMessageVersion3(model: SmsMessageBody, observe?: 'body', reportProgress?: boolean): Observable<MessageResponseDto>;
    public messagePostBroadCastMessageVersion3(model: SmsMessageBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MessageResponseDto>>;
    public messagePostBroadCastMessageVersion3(model: SmsMessageBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MessageResponseDto>>;
    public messagePostBroadCastMessageVersion3(model: SmsMessageBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling messagePostBroadCastMessageVersion3.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MessageResponseDto>(`${this.basePath}/api/Message/postbroadcastmessages`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messagePostShortMessageForProcessing(model: SmsMessageBody, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public messagePostShortMessageForProcessing(model: SmsMessageBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public messagePostShortMessageForProcessing(model: SmsMessageBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public messagePostShortMessageForProcessing(model: SmsMessageBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling messagePostShortMessageForProcessing.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Message/postsms`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messagePostSubscriptionMessage(model: SmsMessageBody, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public messagePostSubscriptionMessage(model: SmsMessageBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public messagePostSubscriptionMessage(model: SmsMessageBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public messagePostSubscriptionMessage(model: SmsMessageBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling messagePostSubscriptionMessage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Message/postsubscriptionmessage`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageRecieveSmsServiceContent(model: ServiceMessageModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public messageRecieveSmsServiceContent(model: ServiceMessageModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public messageRecieveSmsServiceContent(model: ServiceMessageModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public messageRecieveSmsServiceContent(model: ServiceMessageModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling messageRecieveSmsServiceContent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Message/smsrelaypost`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageResendFailedMessage(model: QueuedSmsJobModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public messageResendFailedMessage(model: QueuedSmsJobModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public messageResendFailedMessage(model: QueuedSmsJobModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public messageResendFailedMessage(model: QueuedSmsJobModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling messageResendFailedMessage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/Message/ResendFailedMessage`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
